<div class="wrapper-name">
  <ui-page-header [boxed]="false">{{ shoppingList().name }}</ui-page-header>

  <div class="wrapper-name-controls">
    <button (click)="editShoppingListNameClicked.emit(shoppingList())">
      <ui-icon
        faName="pen-to-square"
        faStyle="light">
      </ui-icon>
    </button>
  </div>
</div>

<div class="wrapper-info">
  <div class="info-item">
    <label>Eigentümer</label>
    <span>{{ shoppingList().owner }}</span>
  </div>
  <div class="info-item">
    <label>Positionen</label>
    <span>{{ productAmount() }}</span>
  </div>
</div>
